import React from 'react';

interface HouseholdMember {
  name: string;
  role: 'child' | 'adult';
}

interface Props {
  members: HouseholdMember[];
  onSelect: (name: string, role: 'child' | 'adult') => void;
  currentSpeaker?: string;
}

export const SpeakerPicker: React.FC<Props> = ({ members, onSelect, currentSpeaker }) => (
  <div className="flex flex-wrap gap-3 items-center">
    <span className="text-sm text-white/50">Speaking:</span>
    {members.map(m => (
      <button
        key={m.name}
        onClick={() => onSelect(m.name, m.role)}
        className={`px-4 py-2 rounded-xl text-sm transition-colors ${
          currentSpeaker === m.name
            ? 'bg-[#5C2D91] text-white'
            : 'bg-white/10 text-white/70 hover:bg-white/20'
        }`}
      >
        {m.name} ({m.role})
      </button>
    ))}
  </div>
);
